const baseURL = "/v1/Faq";

const service = {
  methods: {
    $buscarFaqs(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $visualizarFaq({ params, id }) {
      return this.$api().get(`${baseURL}/${id}`, params);
    },
    $cadastrarFaq(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editarFaq(body, id) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $inativarAtivarFaq(id) {
      return this.$api().patch(`${baseURL}/${id}/AlterarStatus`);
    }
  },
};

export default service;
